import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, output } from '@angular/core';
import { IRemisionLock } from '../../../domain/interfaces/firebase/IremisionLock';
import { PrimengModule } from '../../../primeng/primeng.module';

const ESTADO_PENDIENTE = 'pendiente';
const ESTADO_EN_PROGRESO = 'en-progreso';
const ESTADO_COMPLETADO = 'completado';

export type EstadoPaso =
    | typeof ESTADO_PENDIENTE
    | typeof ESTADO_EN_PROGRESO
    | typeof ESTADO_COMPLETADO;

export interface PasoPipeline {
    label: string;
    descripcion: string;
    estado: EstadoPaso;
}

@Component({
    selector: 'sura-pipeline-estado-novedad',
    imports: [CommonModule, PrimengModule],
    templateUrl: './pipeline-estado-novedad.component.html',
    styleUrl: './pipeline-estado-novedad.component.scss'
})
export class PipelineEstadoNovedadComponent implements OnChanges {

    @Input() estadoLock: IRemisionLock | null | undefined = undefined;
    @Input() visible = false;
    @Input() closable = false;

    cerrar = output<void>();

    pasos: PasoPipeline[] = [
        { label: 'Novedades',     descripcion: 'Envío de novedad',                    estado: ESTADO_EN_PROGRESO },
        { label: 'Programación',  descripcion: 'Creación de citas / novedades',        estado: ESTADO_PENDIENTE   },
        { label: 'Agenda',        descripcion: 'Citas almacenadas en el programador',  estado: ESTADO_PENDIENTE   },
    ];

    get todoCompletado(): boolean {
        return this.estadoLock === null;
    }

    ngOnChanges(): void {
        this.actualizarPasos();
    }

    onCerrar(): void {
        this.cerrar.emit();
    }

    private actualizarPasos(): void {
        if (this.estadoLock === undefined) {return;}

        if (this.estadoLock === null) {
            this.pasos = this.pasos.map(p => ({ ...p, estado: ESTADO_COMPLETADO }));
            return;
        }

        const { estadoNovedades, estadoProgramacion, estadoAgenda } = this.estadoLock;

        this.pasos[0].estado = estadoNovedades ? ESTADO_COMPLETADO : ESTADO_EN_PROGRESO;
        this.pasos[1].estado = this.obtenerEstadoPaso(estadoProgramacion, estadoNovedades);
        this.pasos[2].estado = this.obtenerEstadoPaso(estadoAgenda, estadoProgramacion);
    }

    private obtenerEstadoPaso(estadoActual: boolean, estadoAnterior: boolean): EstadoPaso {
        if (estadoActual) {
            return ESTADO_COMPLETADO;
        }

        if (estadoAnterior) {
            return ESTADO_EN_PROGRESO;
        }

        return ESTADO_PENDIENTE;
    }
}
